import React from 'react';
import '../css/AboutPage.css';
import '../css/navbar.css';

const AboutPage = () => {
  return (
    <div className="about-container">
      <section className="about-hero">
        <div className="about-hero-text">
          <h1>About Our URL Shortener</h1>
          <p>
            Transforming the way you share links, our platform is a modern solution designed to make URLs shorter, simpler, and more effective.
          </p>
        </div>
        <div className="about-hero-image">
          <img
            src="https://via.placeholder.com/800x400"
            alt="Hero illustration"
          />
        </div>
      </section>

      <section className="about-mission">
        <h2>Our Mission</h2>
        <p>
          To empower businesses and individuals with a seamless way to manage and share their digital footprint. We focus on simplicity, speed, and analytics to enhance your online presence.
        </p>
      </section>

      <section className="about-features">
        <h2>What We Offer</h2>
        <div className="features-grid">
          <div className="feature-item">
            <h3>Custom Short URLs</h3>
            <p>Create branded links that are memorable and easy to share.</p>
          </div>
          <div className="feature-item">
            <h3>Detailed Analytics</h3>
            <p>Track clicks, visitor locations, and engagement metrics in real-time.</p>
          </div>
          <div className="feature-item">
            <h3>Seamless Integration</h3>
            <p>Integrate with social media, websites, and marketing campaigns effortlessly.</p>
          </div>
        </div>
      </section>

      <section className="about-technology">
        <h2>Our Technology</h2>
        <p>
          Built using cutting-edge technologies, our platform is designed for reliability and scalability. With features like real-time tracking, secure link management, and API access, we ensure your links are always optimized for performance.
        </p>
      </section>

      <section className="about-cta">
        <h2>Why Choose Us?</h2>
        <p>
          Our platform stands out with its intuitive design, powerful features, and commitment to data security. Join thousands of users who trust us to simplify their digital sharing.
        </p>
        <button className="contact-button">Learn More</button>
      </section>
    </div>
  );
};

export default AboutPage;
